import { render, staticRenderFns } from "./LearningUnitReviewList.vue?vue&type=template&id=ce58f3e6&"
import script from "./LearningUnitReviewList.vue?vue&type=script&lang=js&"
export * from "./LearningUnitReviewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports